import {animatronUserPage} from '../lazy_modules';
import services from 'services/module';
import {FollowersSvc, FollowersSvcFactory} from "./FollowersSvc";

/**
 * Singleton class to track current users followers globally
 * FIXME refresh on logout?
 */
export class MyFollowings {
    followersSvc: FollowersSvc;

    constructor(private $rootScope: ng.IRootScopeService,
                private $ocLazyLoad: oc.ILazyLoad,
                private $q: ng.IQService) {
    }

    public init: () => ng.IPromise<FollowersSvc> = _.once(() => this.$q(resolve => {
        animatronUserPage().then(a => this.$ocLazyLoad.load(a)).then(() => {
            const factory = angular.element(document).injector().get<FollowersSvcFactory>('FollowersSvc');
            this.followersSvc = new factory(true, 'studio-following', false);
            resolve(this.followersSvc);
            this.$rootScope.$on('user:login', () =>
                this.followersSvc = new factory(true, 'studio-following', false)
            );
        });
    }));
}

services.service('MyFollowings', MyFollowings);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/MyFollowings.ts